import "./features/config/Apm";
import RecoilProvider from "./features/recoil/RecoilProvider";
import Router from "./features/router";
import ApiConfig from "./features/config/ApiConfig";
import LogConfig from "./features/config/LogConfig";
import { api } from "./features/config/ApiConfig";

const Base = () => {
    return (
        <RecoilProvider>
            <LogConfig />
            <ApiConfig />
            <Router />
        </RecoilProvider>
    );
};

export { api };
export default Base;
